export const managerFilter = state => state.managerFilter;
